package org.lennycodes.hldi.pages.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.fa.FaDeleteLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaPen
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Table
import org.jetbrains.compose.web.dom.Tbody
import org.jetbrains.compose.web.dom.Td
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Th
import org.jetbrains.compose.web.dom.Thead
import org.jetbrains.compose.web.dom.Tr
import org.lennycodes.hldi.backend.db_service.ConfirmDeleteDialog
import org.lennycodes.hldi.backend.db_service.deleteAdmin
import org.lennycodes.hldi.backend.db_service.deleteMilestone
import org.lennycodes.hldi.backend.db_service.sendResetPassword
import org.lennycodes.hldi.data.Milestone
import org.lennycodes.hldi.styles.AddAdminButtonStyle
import org.lennycodes.hldi.styles.AdminTableStyle
import org.lennycodes.hldi.styles.AvatarBadgeStyle
import org.lennycodes.hldi.styles.DeleteIconButtonStyle
import org.lennycodes.hldi.styles.EditIconButtonStyle
import org.lennycodes.hldi.styles.IconButtonStyle
import org.lennycodes.hldi.styles.NameCellStyle
import org.lennycodes.hldi.styles.TableCardStyle
import org.lennycodes.hldi.styles.TableCellStyle
import org.lennycodes.hldi.styles.TableHeaderCellStyle
import org.lennycodes.hldi.styles.TableRowStyle
import org.lennycodes.hldi.styles.UsersTitleStyle

@Composable
fun About(){
    var selectedMilestone by remember { mutableStateOf<Milestone?>(null) }
    var selectedDeleteMilestone by remember { mutableStateOf<Milestone?>(null) }
    var milestones by remember { mutableStateOf<List<Milestone>>(emptyList()) }
    val scope = rememberCoroutineScope()
    var milestoneDialog by remember { mutableStateOf(false) }
    var refreshKey by remember { mutableStateOf(0) }
    LaunchedEffect(refreshKey){
        milestones = AdminRepository.getAllMilestones()
    }
    if (milestoneDialog) {
        AddMilestoneDialog(
            onDismiss = {
                milestoneDialog = false
            },
            onSuccess = {
                refreshKey++
            }
        )
    }
    //Edit Milestone Dialog
    selectedMilestone?.let { milestone ->

        EditMilestoneDialog(
            milestone = milestone,

            onDismiss = {
                selectedMilestone = null
            },

            onSuccess = {
                refreshKey++
                selectedMilestone = null
            }
        )

    }
    //Delete Milestone Dialog
    selectedDeleteMilestone?.let { milestone ->

        ConfirmDeleteMilestone(

            milestone = milestone,

            onDismiss = {
                selectedDeleteMilestone = null
            },

            onConfirm = {

                scope.launch {

                    deleteMilestone(
                        milestone.id
                    )

                    refreshKey++

                    selectedDeleteMilestone = null

                }

            }
        )

    }
    Column(
        modifier = Modifier.fillMaxWidth() .padding(32.px),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Top
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.px),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {

            H3(
                attrs = UsersTitleStyle.toAttrs()
            ) {
                Text("Milestones List")
            }
            Button(
                modifier = Modifier
                    .padding(10.px, 20.px)
                    .then(AddAdminButtonStyle.toModifier()),

                onClick = {
                    // Open Add Admin dialog/page
                    milestoneDialog =!milestoneDialog
                }
            ) {
                Text("+ New Milestone")
            }
        }
        Div(attrs = TableCardStyle.toAttrs()) {
            Table(attrs = AdminTableStyle.toAttrs()) {
                Thead {
                    Tr {
                        listOf("S/N", "Year", "Description", "Actions").forEach { title ->
                            Th(attrs = Modifier.padding(14.px, 16.px).then( TableHeaderCellStyle.toModifier()).toAttrs()) {
                                Text(title)
                            }
                        }
                    }
                }

                Tbody {
                    milestones.forEachIndexed { index, milestone ->
                        Tr(attrs = TableRowStyle.toAttrs()) {
                            Td(attrs = Modifier.padding(14.px, 16.px).then( TableCellStyle.toModifier()).toAttrs()) {
                                Text((index + 1).toString())
                            }

                            Td(attrs = Modifier.padding(14.px, 16.px).then( TableCellStyle.toModifier()).toAttrs()) {
                                Text(milestone.year)
                            }
                            Td(
                                attrs = Modifier
                                    .padding(14.px, 16.px)
                                    .width(300.px)
                                    .toAttrs {
                                        style {
                                            property("max-width", "300px")
                                            property("overflow-wrap", "break-word")
                                        }
                                    }
                            ) {
                                Text(milestone.description)
                            }

                            Td(attrs = Modifier.padding(14.px, 16.px).then( TableCellStyle.toModifier()).toAttrs()){
                                Row(
                                    horizontalArrangement = Arrangement.spacedBy(8.px),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Button(
                                        modifier = Modifier.then(EditIconButtonStyle.toModifier())
                                            .then(IconButtonStyle.toModifier()),
                                        onClick = {
                                             selectedMilestone = milestone
                                            /* Edit admin */
                                        }
                                    ) {
                                        FaPen()
                                    }

                                    Button(
                                        modifier =  Modifier.then(DeleteIconButtonStyle.toModifier())
                                            .then(IconButtonStyle.toModifier()),
                                        onClick = { /* Delete admin */
                                            selectedDeleteMilestone = milestone
                                        }
                                    ) {
                                        FaDeleteLeft()
                                    }


                                }
                            }
                        }
                    }
                }
            }
        }
    }
}